exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attachment-list[data-v-467ab121] {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 3px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.attachment-list a[data-v-467ab121] {\n    cursor: pointer;\n    color: black;\n    font-size: 13px;\n}\n", ""]);

// exports
